// extracted by mini-css-extract-plugin
export default {"TagsSelectorSelect":"TagsSelector_TagsSelectorSelect__wUOF5"};